<template>
  <div class="orders-list-order-group-wrapper">
    <van-list
      finished-text="没有更多了"
      :loading="loading"
      :finished="finished"
      :immediate-check="false"
      @load="handleLoad"
    >
      <display-order-card
        v-for="item of items"
        :key="item.id"
        :value="item"
        :spotTitle="spotTitle"
        @refund="handleRefund"
      />
    </van-list>
  </div>
</template>
<script>
import DisplayOrderCard from '@/components/DisplayOrderCard.vue';

export default {
  components: {
    DisplayOrderCard,
  },
  props: {
    items: [Array],
    loading: [Boolean],
    finished: [Boolean],
    spotTitle: [String],
  },
  methods: {
    handleLoad() {
      this.$emit('load', this.error);
    },
    handleRefund(code, spotId) {
      this.$emit('refund', code, spotId);
    },
  },
};
</script>
<style lang="less" scoped></style>
